<template>
  <div class="h-full overflow-auto" :class="$style['landing-background']">
    <div class="mb-20">
      <div class="mx-auto mt-10 grid grid-cols-1 items-start gap-10 sm:px-5 md:px-8 xl:grid-cols-2 3xl:grid-cols-3">
        <div class="flex min-w-0 flex-col gap-10">
          <LandingCard variant="info" :title="`Welcome, ${userRef.firstName} ${userRef.lastName}`">
            <template #default>
              <LandingCardLinkSections label="Facilities">
                <LandingCardLinkSection
                  link-label="Find Facilities"
                  description="Find, view, and manage underground storage tank facilities"
                  :to="{ name: routeNames.facilities.facilities }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="Tanks">
                <LandingCardLinkSection
                  link-label="Find Tanks"
                  description="Find, view, and manage underground storage tanks"
                  :to="{ name: routeNames.tank.tanks }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="Permits">
                <LandingCardLinkSection
                  link-label="Find Permits"
                  description="Find, view, and manage underground storage tank permits"
                  :to="{ name: routeNames.permit.permits }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="Release Events">
                <LandingCardLinkSection
                  link-label="Find Release Events"
                  description="Find, view, and manage underground storage tank release events"
                  :to="{ name: routeNames.releaseEvent.releaseEvents }"
                />
              </LandingCardLinkSections>
              <LandingCardLinkSections label="Compliance Events">
                <LandingCardLinkSection
                  link-label="Find Compliance Events"
                  description="Find, view, and manage underground storage tank compliance events"
                  :to="{ name: routeNames.complianceEvent.complianceEvents }"
                />
              </LandingCardLinkSections>
            </template>
          </LandingCard>
        </div>
        <div class="flex min-w-0 flex-col gap-10 xl:col-start-2 3xl:contents">
          <div class="flex min-w-0 flex-col gap-10 3xl:col-start-2">
            <LandingCard title="Facilities" :view-all-to="{ name: routeNames.facilities.facilities }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
            <LandingCard title="Tanks" :view-all-to="{ name: routeNames.tank.tanks }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
            <LandingCard title="Permits" :view-all-to="{ name: routeNames.permit.permits }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
          </div>
          <div class="flex min-w-0 flex-col gap-10 3xl:col-start-3">
            <LandingCard title="Release Events" :view-all-to="{ name: routeNames.releaseEvent.releaseEvents }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
            <LandingCard title="Compliance Events" :view-all-to="{ name: routeNames.complianceEvent.complianceEvents }">
              <div class="bg-neutral-50 p-10 sm:rounded-b-lg">
                <NoneFoundFlag label="Coming Soon" />
              </div>
            </LandingCard>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { routeNames } from "@/routes";
import { BaseButton } from "@modernary/mui/components/button";
import { MdrnFooter, NoneFoundFlag, useAppSettingsStore } from "@modernary/mui/components/common";
import { useUser } from "@modernary/mui/utils/authentication";
import { LogoutButton } from "@modernary/mui/utils/authentication/buttons";
import { defineComponent } from "vue";
import LandingCard from "./landing/LandingCard.vue";
import LandingCardLinkSection from "./landing/LandingCardLinkSection.vue";
import LandingCardLinkSections from "./landing/LandingCardLinkSections.vue";

export default defineComponent({
  name: "HomeInternal",
  setup() {
    const { userRef } = useUser();
    const appSettingsStore = useAppSettingsStore();

    return {
      userRef,
      routeNames,
      BaseButton,
      appSettingsStore,
    };
  },
  components: {
    LogoutButton,
    MdrnFooter,
    LandingCard,
    LandingCardLinkSection,
    LandingCardLinkSections,
    NoneFoundFlag,
  },
});
</script>

<style lang="css" module>
.landing-background {
  background-color: #363a3d; /* average color from the sky of the bg */
  background-image: url("/images/backgrounds/bg-ust.webp");
  background-size: cover;
  background-position: left 0;
  background-repeat: no-repeat;
}
</style>
